import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './tire-tread-manufacturer.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const TireTreadManufacturerDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireTreadManufacturerEntity = useAppSelector(state => state.tireTreadManufacturer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tireTreadManufacturerDetailsHeading">
          <Translate contentKey="fleetSenseApp.tireTreadManufacturer.detail.title">TireTreadManufacturer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tireTreadManufacturerEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.tireTreadManufacturer.name">Name</Translate>
            </span>
          </dt>
          <dd>{tireTreadManufacturerEntity.name}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="fleetSenseApp.tireTreadManufacturer.image">Image</Translate>
            </span>
          </dt>
          <dd>
            {tireTreadManufacturerEntity.image ? (
              <div>
                {tireTreadManufacturerEntity.imageContentType ? (
                  <a onClick={openFile(tireTreadManufacturerEntity.imageContentType, tireTreadManufacturerEntity.image)}>
                    <img
                      src={`data:${tireTreadManufacturerEntity.imageContentType};base64,${tireTreadManufacturerEntity.image}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {tireTreadManufacturerEntity.imageContentType}, {byteSize(tireTreadManufacturerEntity.image)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fleetSenseApp.tireTreadManufacturer.company">Company</Translate>
          </dt>
          <dd>{tireTreadManufacturerEntity.company ? tireTreadManufacturerEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/tire-tread-manufacturer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tire-tread-manufacturer/${tireTreadManufacturerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TireTreadManufacturerDetail;
